import { isEmpty } from "lodash";
import React from "react";

const RenderSkyOdds = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  betType,
  active,
}) => {
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0 || !isEmpty(odds)) {
        if (Number(odds) > limit?.oddsLimit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  return (
    <dd className="backlay_box">
      <dl className="back-gradient">
        {odds_back?.length > 0 ? (
          odds_back?.slice(0, 1)?.map((res, id) => {
            let chamak =
              oldBack?.length > 0
                ? res?.rt != oldBack[id]?.rt || res?.bv != oldBack[id]?.bv
                : false;
            return (
              <dd
                style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
                onClick={(e) => {
                  if (disabelBack) {
                  } else {
                    if (!checkDisabled(res?.rt)) {
                      handelChange(res, "back", item?.RunnerName, item, e);
                    }
                  }
                }}
                id="back_1"
                className={`${chamak ? "spark" : ""} ${
                  active && betType == "back" ? "select" : ""
                }`}
              >
                <div className={`lay-back-block bookmaker-odds `}>{res?.rt || ""}</div>
              </dd>
            );
          })
        ) : (
          <dd id="back_1">
            <div className="lay-back-block bookmaker-odds"></div>
          </dd>
        )}
      </dl>
      <dl className="lay-gradient">
        {odds_lay?.length > 0 ? (
          odds_lay?.slice(0, 1)?.map((res, id) => {
            let chamak =
              oldLay?.length > 0
                ? res?.rt != oldLay[id]?.rt || res?.bv != oldLay[id]?.bv
                : false;
            return (
              <dd
                onClick={(e) => {
                  if (disabelLay) {
                  } else {
                    if (!checkDisabled(res?.rt)) {
                      handelChange(res, "lay", item?.RunnerName, item, e);
                    }
                  }
                }}
                style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
                id="lay_1"
                className={`${chamak ? "spark" : ""} ${
                  active && betType == "lay" ? "select" : ""
                }`}
              >
                <div className={`lay-back-block bookmaker-odds `}>{res?.rt || ""}</div>
              </dd>
            );
          })
        ) : (
          <dd id="lay_1" className>
            <div className="lay-back-block bookmaker-odds"></div>
          </dd>
        )}
      </dl>{" "}
      {disableFull && (
        <dd id="suspend" className="suspend-fancy">
          <p id="info">Suspend</p>
        </dd>
      )}
    </dd>
  );
};

export default RenderSkyOdds;
